<form #kvForm="ngForm" name="kvForm" class="form" method="post">
    <div>
    	<label for="inputOldPass" class="loginLabel">{{LOCALIZATION.passwordOld}}</label>
        <input 
        	type="password" 
        	[(ngModel)]='input.oldpass' 
        	id="inputOldPass" 
        	name="oldpass"
        	class="form-control" 
        	placeholder="{{LOCALIZATION.passwordOld}}" 
        	required />
    </div>
    <div>
        <label for="inputNewPass" class="loginLabel">{{LOCALIZATION.passwordNew}}</label>
		<input uib-tooltip-html="popoverHTML" tooltip-is-open="showPolicy" tooltip-trigger="none" tooltip-placement="top" tooltip-class="checklist"
			type="password" 
        	[(ngModel)]='input.newpass' 
        	id="inputNewPass" 
        	name="newpass" 
        	class="form-control" 
        	placeholder="{{LOCALIZATION.passwordNew}}" 
        	(change)="validatePassword()" 
        	(focus)="showPolicy=true" 
        	(blur)="showPolicy=false"
        	required />
		<span *ngIf="showPolicy" [innerHTML]="popoverHTML"></span>        
    </div>
    <div>
    	<label for="inputNewPassConfirm" class="loginLabel">{{LOCALIZATION.passwordRetype}}</label>
        <input 
        	type="password" 
        	[(ngModel)]='input.newpass2' 
        	id="inputNewPassConfirm" 
        	name="newpass2"
        	class="form-control" 
        	placeholder="{{LOCALIZATION.passwordRetype}}" 
        	required />
    </div>
    <br>
    <button 
    	(click)="updatePassword()" 
    	[disabled]="!kvForm.valid" 
    	type="submit" 
    	class="btn btn-primary pull-right" 
    	title="{{LOCALIZATION.changePassword}}">
    		{{LOCALIZATION.changePassword}}
    </button>    
</form>
